// Write your JS code here
import './index.css'

const About = () => (
  <div className="route-container">
    <img
      src="https://assets.ccbp.in/frontend/react-js/about-blog-img.png"
      alt="about"
      className="route-image"
    />
    <h1 className="route-heading">About</h1>
    <p className="about-description">
      I love to create! I am a front-end web developer.
    </p>
  </div>
)

export default About
